import { ServiceProvider } from "./service.provider";
import { BaseService } from "./base.service";
import { HttpHeaders } from "@angular/common/http";
import { Injectable } from "@angular/core";
export let user_type = 'DMS';


export class DMSBaseService extends BaseService {
  constructor(public endpoint: string, public provider: ServiceProvider, userType?) {
    super(endpoint, provider);
  }

  public getHeaders(): HttpHeaders {
    const headers: HttpHeaders = new HttpHeaders({
      'Content-Type': 'application/json',
      'USER_TYPE':user_type,
    });
    return headers;
  }
}

@Injectable()
export class DMSBaseServiceImp {
  constructor(usertype){
    user_type = usertype ? usertype : 'DMS'; 
  }
}
